import React from 'react';
import { connect } from 'react-redux'

const kennitala = require('kennitala')
import { createEmployerAccess } from '../../api/employer-access/actions'

import connectWithStore from '../../utils/store'

import { store } from '../../store'


class EmployerAccessRequest extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            search: "",
            hasAccessForSelf: false
        }

        this.isValidSearch = this.isValidSearch.bind(this);
        this.accesTypeSelect = this.accesTypeSelect.bind(this);
    }

    componentDidMount() {
        if (
            this.props.employerAccess &&
            this.props.employerAccess.data &&
            Object.keys(this.props.employerAccess.data).length > 0) {
            const userKennitala = this.props.employerAccess.data.kennitala;
            const hasIndividualAccess = this.props.employerAccess.data.access.findIndex(itm => itm.company.company_id === userKennitala);
            if (hasIndividualAccess !== -1) {
                this.setState({hasAccessForSelf: true});
            }            
        }
    }

    componentDidUpdate(prevProps) {
        const prevEA = prevProps && prevProps.employerAccess && prevProps.employerAccess.data;
        const curEA = this.props && this.props.employerAccess && this.props.employerAccess.data;

        if (prevEA === curEA) return;

        const userKennitala = curEA && curEA.kennitala;
        const accessArr = curEA && Array.isArray(curEA.access) ? curEA.access : [];

        if (!userKennitala || !accessArr.length) return;

        const hasIndividualAccess = accessArr.findIndex(itm => itm && itm.company && itm.company.company_id === userKennitala);

        if (hasIndividualAccess !== -1) {
            this.setState({ hasAccessForSelf: true });
        }        
    }



    isValidSearch(type) {
        if (type === "3rdparty")
            return kennitala.isCompany(this.state.search)
        else
            return kennitala.isPerson(this.state.search)
    }


    for3rdParty(type) {
        const prompt = type === "3rdparty" ? "Sækja um aðgang að fyrirtæki" : "Sækja um aðgang fyrir einstakling";
        const type_prompt = type === "3rdparty" ? "fyrirtækis" : "einstaklings"
        return(
            <div className="edit-company">
                <div className="xs-mb-20"><strong>{prompt}</strong></div>
                { this.props.employerAccess.employerAccessError !== "" &&
                    <div className="alert alert-danger">
                        { this.props.employerAccess.employerAccessError }
                    </div>
                }
                <div className="form-row">
                    <div className="col-sm-4"><label htmlFor="" className="">Kennitala {type_prompt}</label></div>
                    <div className="col-sm-8 text-left">
                        <input value={this.state.search} onChange={(e) => this.setState({search: e.target.value})} placeholder={`Sláðu inn kennitölu ${type_prompt}`} />
                    </div>
                </div>
                <div className="form-row xs-pt-20">
                    <div className="col-sm-4"></div>
                    <div className="col-sm-8 text-left">
                        <button disabled={!this.isValidSearch(type) || this.props.employerAccess.isFetching} className="btn btn-primary m-0" onClick={() => this.props.dispatch(createEmployerAccess({company_id: this.state.search.replace('-','')}))}>Sækja um aðgang</button>
                    </div>
                </div>
                
            </div>
        );
    }

    forSelf() {
        const userKennitala = (this.props && this.props.employerAccess && this.props.employerAccess.data.kennitala ? this.props.employerAccess.data.kennitala : '').replace('-','');
        if (userKennitala)
            return (
                <div className="for-self">
                    <div className="form-row">
                        <div className="col-sm-4"></div>
                        <div className="col-sm-8 text-left">
                            <button className="btn btn-primary m-0" onClick={() => this.props.dispatch(createEmployerAccess({company_id: userKennitala}))}>Staðfesta</button>
                        </div>
                    </div>

                </div>
            );
        else
            return(
                <div className="for-self">
                    vantar kennitölu!
                </div>
            );
    }

    accesTypeSelect(e) {
        this.setState({ search: "", accessType: e.target.value });
    }

    accessTypeContent() {
        switch (this.state.accessType) {
            case "3rdparty":
            case "3rdparty-individual":
                return this.for3rdParty(this.state.accessType);
            case "for-self":
                return this.forSelf();
            default:
                return <></>;
        }
    }

    render() {
        return (
            <div className="access-type">
                <h3>Aðgangsbeiðni</h3>
                <div style={{flexDirection: "row-reverse", marginTop: "20px"}}>
                    <div style={{display: 'inline-flex'}}>
                        <input id="employer-access-1" style={{width:"unset",marginRight: "10px", marginTop:"-5px"}} type="radio" name="employer-access-type" value="3rdparty" onChange={this.accesTypeSelect}/>
                        <label htmlFor="employer-access-1">Fyrir hönd fyrirtækis</label>
                        {
                        !this.state.hasAccessForSelf ?
                            <>
                            <input id="employer-access-2" style={{width:"unset",marginRight: "10px",marginLeft: "10px", marginTop:"-5px"}} type="radio" name="employer-access-type" value="for-self" onChange={this.accesTypeSelect}/>
                            <label htmlFor="employer-access-2">Fyrir eigin hönd</label>
                            </>
                        : <></>
                        }
                        <input id="employer-access-3" style={{width:"unset",marginRight: "10px",marginLeft: "10px", marginTop:"-5px"}} type="radio" name="employer-access-type" value="3rdparty-individual" onChange={this.accesTypeSelect}/>
                        <label htmlFor="employer-access-3">Fyrir hönd einstaklings</label>
                    </div>
                </div>
                {this.accessTypeContent()}
            </div>
        )
    }
}

EmployerAccessRequest.defaultProps = {
}


function mapStateToProps(state) {

    var f = {
        employerAccess: {},
    }
    f.employerAccess = (state.employerAccess === undefined) ? {} : state.employerAccess
    return f;
}


export default connectWithStore(store, EmployerAccessRequest, mapStateToProps);